/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_VillaInputs */

const en_val_villa = /** @type {(inputs: Val_VillaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Villa`)
};

const es_val_villa = /** @type {(inputs: Val_VillaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Villa`)
};

const fr_val_villa = /** @type {(inputs: Val_VillaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Villa`)
};

const de_val_villa = /** @type {(inputs: Val_VillaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Villa`)
};

const ja_val_villa = /** @type {(inputs: Val_VillaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヴィラ`)
};

const zh_val_villa = /** @type {(inputs: Val_VillaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`别墅`)
};

const ar_val_villa = /** @type {(inputs: Val_VillaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فيلا`)
};

const id_val_villa = /** @type {(inputs: Val_VillaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vila`)
};

const it_val_villa = /** @type {(inputs: Val_VillaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Villa`)
};

const ru_val_villa = /** @type {(inputs: Val_VillaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вилла`)
};

const pt_val_villa = /** @type {(inputs: Val_VillaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vila`)
};

const ko_val_villa = /** @type {(inputs: Val_VillaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`빌라`)
};

/**
* | output |
* | --- |
* | "Villa" |
*
* @param {Val_VillaInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_villa = /** @type {((inputs?: Val_VillaInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_VillaInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_villa(inputs)
	if (locale === "es") return es_val_villa(inputs)
	if (locale === "fr") return fr_val_villa(inputs)
	if (locale === "de") return de_val_villa(inputs)
	if (locale === "ja") return ja_val_villa(inputs)
	if (locale === "zh") return zh_val_villa(inputs)
	if (locale === "ar") return ar_val_villa(inputs)
	if (locale === "id") return id_val_villa(inputs)
	if (locale === "it") return it_val_villa(inputs)
	if (locale === "ru") return ru_val_villa(inputs)
	if (locale === "pt") return pt_val_villa(inputs)
	return ko_val_villa(inputs)
});